import PageLayout from "@/components/PageLayout";
import PageHeader from "@/components/PageHeader";
import { motion } from "framer-motion";
import { Dumbbell } from "lucide-react";
import SEO from "@/components/SEO";

const equipment = [
  "Painopakkalaitteet (Ironfit, HCPro, Precor, GPF, Life Fitness)",
  "Vipuvarsilaitteet (Goljat, HCPro, Marbo, GPF, David)",
  "Kilpailustandardi penkkipunnerruspenkit (ROGUE)",
  "Käsipainot 1–60 kg",
  "Laaja valikoima tankoja ja levypainoja 50 kg asti",
  "Vapaapainoharjoittelualueet",
  "Juoksumattoja, crosstrainereita, soutulaitteita ja kuntopyöriä",
  "Vapaata jumppa- ja venyttelytilaa",
];

export default function KuntosalitPage() {
  return (
    <PageLayout>
      <SEO title="Kuntosalit — Kuntosali Takomo, Jokela & Kellokoski" description="Modernit kuntosalit Jokelassa ja Kellokoskella. Laadukkaat laitteet, vapaat painot ja monipuoliset treenitilat. Jokela 24/7, Kellokoski 05–22." path="/kuntosalit" />
      <PageHeader title="Kuntosalit" subtitle="Kaksi kuntosalia samalla kortilla — Jokela & Kellokoski" />

      <section className="section-padding">
        <div className="container mx-auto max-w-5xl">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
            <motion.div initial={{ opacity: 0, x: -20 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }}>
              <img src="/images/gym-main.jpg" alt="Kuntosali Takomo" className="rounded-lg w-full object-cover aspect-[4/3]" loading="lazy" />
            </motion.div>

            <motion.div initial={{ opacity: 0, x: 20 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }}>
              <h2 className="font-display text-2xl md:text-3xl font-bold mb-4 text-foreground">
                Salit Jokelan ja Kellokosken keskustassa
              </h2>
              <div className="divider-primary mb-6" />
              <div className="text-muted-foreground space-y-4 leading-relaxed">
                <p>Kuntosalit aivan Jokelan ja Kellokosken keskustassa!</p>
                <p>Jokelan kuntosali on K-kauppaa vastapäätä, entisissä valintatalon tiloissa.</p>
                <p>Kellokosken kuntosali löytyy keskustieltä, alepan ja apteekin väistä.</p>
                <p>Voit käyttää molempia saleja samalla kortilla.</p>
                <p>Molemmat kuntosalit on suunniteltu niin, että kaikki voivat kuntotasostaan riippumatta treenata meillä.</p>
                <p>Meillä on laaja ja laadukas laitevalikoima, hyvät vapaapainoalueet sekä monipuoliset aerobiset laitteet ja välineet.</p>
                <p>Molemmat kuntosalit ovat tilaltaan noin 400m² ja Jokelassa lisäksi ulkosali!</p>
                <p>Olemme paljon paikalla kuntosaleillamme ja autamme mielellämme asiakkaita kuntoilun pariin.</p>
                <p>Meiltä saa aina tulla kysymään apua laitteiden käytössä ja oikeissa suoritustekniikoissa.</p>
                <p>Voit tulla tutustumaan kuntosaleihimme päivystysaikoina.</p>
                <p>Tervetuloa!</p>
              </div>
              <p className="text-foreground/80 text-sm italic mt-6">— Priyanti Tuunainen & Sami Rautiainen</p>
            </motion.div>
          </div>

          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="mt-16">
            <h2 className="font-display text-2xl md:text-3xl font-bold mb-2 text-foreground">Laitteet & Välineet</h2>
            <div className="divider-primary mb-8" />
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {equipment.map((e) => (
                <div key={e} className="flex items-start gap-3 bg-card-premium rounded-lg p-4">
                  <Dumbbell size={18} className="text-primary mt-0.5 shrink-0" />
                  <span className="text-foreground/80 text-sm">{e}</span>
                </div>
              ))}
            </div>
          </motion.div>

          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="mt-16 bg-card-premium rounded-lg p-8">
            <h2 className="font-display text-2xl font-bold mb-2 text-foreground">Lisäravinteet</h2>
            <div className="divider-primary mb-4" />
            <p className="text-muted-foreground leading-relaxed">
              Valikoimassamme SELF Omninutritionin tuotteet — yli 12 vuoden kokemuksella markkinoiden parhaita ravintolisiä urheilijoille ja jokapäiväiseen hyvinvointiin. Kaikissa tuotteissa käytetään vain parhaita, turvallisiksi todettuja ainesosia.
            </p>
          </motion.div>
        </div>
      </section>
    </PageLayout>
  );
}
